import { Box, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { attributes, attributeThemeColors } from '../attributes'
import ScoreSlider from './ScoreSlider'
import React from 'react'

export default function PerformanceScoringTable({ handleScoreChange, scores }) {
  return (
    <Box>
      <Table
        mt={7}
        fontSize={'md'}
        sx={{ '@media print': { width: '800px !important' } }}
      >
        <Thead>
          <Tr
            sx={{
              '& th': { fontWeight: 'extrabold', fontSize: 'md' },
            }}
          >
            <Th>Theme</Th>
            <Th isNumeric>Statement</Th>
            <Th
              sx={{
                '@media print': {
                  textAlign: 'right',
                },
              }}
            >
              Performance Score Input
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {attributes.map(({ theme, statement, importance }, i) => {
            return (
              <Tr key={i}>
                <Td color={attributeThemeColors[theme]}>{theme}</Td>
                <Td
                  isNumeric
                  minWidth={{ xs: '200px', sm: '350px', xl: '500px' }}
                >
                  {statement}
                </Td>
                <ScoreSlider
                  statementIndex={i}
                  handleChange={score => handleScoreChange(statement, score)}
                  bgcolor={`${attributeThemeColors[theme]}`}
                  score={scores[statement].score}
                  minWidth={{
                    base: '300px',
                    lg: '400px',
                    xl: '450px',
                  }}
                  sx={{ '@media print': { minWidth: '20px' } }}
                />
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </Box>
  )
}
